import externalAdminFiltersToString, { ExternalAdminFilters } from './externalAdminFiltersToString'
import fetchItems from './fetchItems'

interface FetchUsersProps {
  filters: ExternalAdminFilters
  lmiAccountKey?: string
}

export const fetchUsers = async ({ filters, lmiAccountKey }: FetchUsersProps) => {
  return fetchItems({
    type: 'users',
    useExternalAdmin: true,
    filters: externalAdminFiltersToString({ ...filters }),
    lmiAccountKey,
  })
}
